import { useRouter } from 'next/router';
import { memo, type ReactNode, useCallback } from 'react';

import { useShortIdContext } from '@air/provider-short-id';

import { usePublicWorkspace } from '~/components/PublicWorkspaceProvider';
import { SocketContextProvider } from '~/providers/SocketContext/SocketContext';

export type PublicClipSocketContextProviderProps = {
  children: ReactNode;
};

export const PublicClipSocketContextProvider = memo(({ children }: PublicClipSocketContextProviderProps) => {
  const { isReady } = useRouter();
  const { shortId } = useShortIdContext();
  const { workspaceId } = usePublicWorkspace();
  const getAuthToken = useCallback(() => Promise.resolve(shortId), [shortId]);

  return (
    <SocketContextProvider connect={isReady} getAuthToken={getAuthToken} currentWorkspaceId={workspaceId}>
      {children}
    </SocketContextProvider>
  );
});

PublicClipSocketContextProvider.displayName = '_PublicClipSocketContextProvider';
